import { AUDIENCE_TYPES, getAudienceDescription } from "posts/constants";
import {
  COLORS,
  DEFAULT_TRANSITION_ALL,
  getAudienceTypeColor,
  BREAKPOINT,
} from "utils/styles";
import React from "react";

import Card from "components/Card";
import IconButton from "components/IconButton";
import styled from "styled-components";
import AudienceEmoji from "components/AudienceEmoji";

const A = styled.a`
  color: ${COLORS.BLACK};
  text-decoration: none;
  &:hover {
    color: ${COLORS.BLACK};
    text-decoration: none;
  }
  display: block;
  height: 100%;
  padding-bottom: 1rem;
`;

const Wrapper = styled(Card)`
  background: ${({ backgroundColor }) => backgroundColor};
  overflow: hidden;
  position: relative;
  height: 100%;
`;

const ContentWrapper = styled.div`
  ${DEFAULT_TRANSITION_ALL};
  width: 200%;
  display: grid;
  grid-template-columns: 50% 50%;
`;

const Content = styled.div`
  ${DEFAULT_TRANSITION_ALL};
  opacity: ${({ visible }) => (visible ? 1 : 0)};
`;

const Title = styled.h2.attrs(() => ({
  className: "mabry-medium",
}))`
  ${DEFAULT_TRANSITION_ALL};
  position: absolute;
  top: 2rem;
  left: 2rem;
  font-weight: 500;
  font-size: 2.25rem;
  @media ${BREAKPOINT.M} {
    font-size: 1.5rem;
    margin-left: -0.5rem;
  }
`;

const HelpIconWrapper = styled(IconButton)`
  position: absolute;
  top: 2rem;
  right: 2rem;
  z-index: 10;
`;

const Description = styled.span.attrs(() => ({
  className: "mabry-regular",
}))`
  font-size: 1.125rem;
  margin-top: 10.25rem;
  margin-bottom: 1.5rem;
  display: block;
  @media ${BREAKPOINT.M} {
    font-size: 1rem;
  }
`;

const DescriptionSubtitle = styled.span`
  font-size: 1.125rem;
  display: block;
  @media ${BREAKPOINT.M} {
    font-size: 1rem;
  }
`;

function ZeroStateAudienceCard({ audience, urlPrefix }) {
  const getBackgroundColor = () => {
    return getAudienceTypeColor(audience) || COLORS.WHITE;
  };

  const renderDescriptionSubtitle = () => {
    if (audience === AUDIENCE_TYPES.PEOPLE_POWER) {
      return (
        <span>
          45% people of color, 60% women, and more than 40% college educated,{" "}
          <em>People Power</em> is super-secular and super-progressive.
        </span>
      );
    }
    if (audience === AUDIENCE_TYPES.IF_YOU_SAY_SO) {
      return (
        <span>
          About half men, half people of color, a little over half Democrats,{" "}
          <em>If You Say So</em> stands out more for their cultural profile than
          for their demographics.
        </span>
      );
    }
    if (audience === AUDIENCE_TYPES.TOUGH_COOKIES) {
      return (
        <span>
          Racially and politically diverse—about a third identify as Democrat,
          Republican, and Independent, respectively—<em>Tough Cookies</em> are
          the oldest group. More than half are over 55.
        </span>
      );
    }
    if (audience === AUDIENCE_TYPES.DONT_TREAD_ON_ME) {
      return (
        <span>
          <em>Don't Tread on Me</em> is whiter, more likely to identify as
          Republican, more likely to go to church, and earns more than any other
          audience.
        </span>
      );
    }
  };

  const getUrl = () => {
    switch (audience) {
      case AUDIENCE_TYPES.PEOPLE_POWER:
        return `${urlPrefix}/people-power`;
      case AUDIENCE_TYPES.IF_YOU_SAY_SO:
        return `${urlPrefix}/if-you-say-so`;
      case AUDIENCE_TYPES.TOUGH_COOKIES:
        return `${urlPrefix}/tough-cookies`;
      case AUDIENCE_TYPES.DONT_TREAD_ON_ME:
        return `${urlPrefix}/dont-tread-on-me`;
    }
  };

  return (
    <A href={getUrl()}>
      <Wrapper backgroundColor={getBackgroundColor()}>
        <Title>
          <AudienceEmoji audience={audience} />
          {audience}
        </Title>
        <ContentWrapper>
          <Content visible={true}>
            <Description>{getAudienceDescription(audience)}</Description>
            <DescriptionSubtitle>
              {renderDescriptionSubtitle()}
            </DescriptionSubtitle>
          </Content>
        </ContentWrapper>
      </Wrapper>
    </A>
  );
}

export default ZeroStateAudienceCard;
